import { css } from 'styled-components';

export const internalLinkWrapperStyles = css`
  padding: 10px 0;
  width: fit-content;
  white-space: nowrap;
`;